import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formatCurrency } from 'src/utils/currency';

//TODO: when payments are complete add to sprc to get po details
//iterate over results and render a row for each

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
  },
  fontWeightMedium: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  cardHeader: {
    color: theme.palette.secondary.main,
  },
}));

function NSDPayments({ poPaymentAmount}) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardHeader
        className={classes.cardHeader}
        title="NSD Payments"
      />
      <Divider />
      <Table>
        <TableBody>
          {poPaymentAmount != null ? (
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>WEX Card</TableCell>
              <TableCell align="right">
                <Typography variant="body2" color="textSecondary">
                  {formatCurrency(poPaymentAmount)}
                </Typography>
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </Card>
  );
}

NSDPayments.propTypes = {
  poPaymentAmount: PropTypes.poPaymentAmount,
};

export default NSDPayments;
